import { h } from 'preact';
export const Coffee = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("path", { d: "M18 8h1a4 4 0 0 1 0 8h-1" }),
        h("path", { d: "M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" }),
        h("line", { x1: "6", y1: "1", x2: "6", y2: "4" }),
        h("line", { x1: "10", y1: "1", x2: "10", y2: "4" }),
        h("line", { x1: "14", y1: "1", x2: "14", y2: "4" })));
};
//# sourceMappingURL=coffee.js.map